import React from "react";
import FormSelect from "../../../../../../components/Forms/FormSelect";
import { JSInputComponent, JSInputProps } from "../JamezzStylesCSSInput";
import { MenuItem } from "@mui/material";

function AlignItems({ name, required }: JSInputProps) {
  return (
    <FormSelect
      name={name}
      nullable
      options={[
        <MenuItem key={"Default"} value={""}>
          Default
        </MenuItem>,
        ["center", "flex-start", "flex-end"].map((value) => (
          <MenuItem key={value} value={value}>
            {value}
          </MenuItem>
        )),
      ]}
      rules={{ required }}
    />
  );
}

export const JSAlignItemsComponent: JSInputComponent = {
  Component: AlignItems,
  handlesCssProperties: ["alignItems"],
};
